/**
 * @Author: wuyang
 * @Date: 2024/1/19
 * @Description: ""
 */

import { requestInstance } from './instance'
import { EBizPhone } from '@/types/bizPhone'
import { ITaskResultImage } from '@/types/task'

/**
 * 收藏/取消收藏图片接口
 * @param type
 */
export const followImage = ({
	imageId,
	follow
}: {
	imageId: string
	follow: boolean
}) => {
	return requestInstance
		.post<any, any>(`/oridinal-image/result/edit`, {
			imageId,
			follow: follow ? 1 : 0
		})
		.fire()
}

/**
 * 点赞/点踩图片接口
 * @param type
 */
export const likeImage = ({
	imageId,
	like
}: {
	imageId: string
	like: boolean
}) => {
	return requestInstance
		.post<any, any>(`/oridinal-image/result/edit`, {
			imageId,
			zan: like ? 1 : 2
		})
		.fire()
}

/**
 * 查询用户收藏图片列表
 */

export const getFollowImageList = ({
	type,
	pageSize,
	pageNum
}: {
	type: EBizPhone
	pageNum: number
	pageSize: number
}) => {
	return requestInstance.get<
		any,
		{
			total: number
			data: ITaskResultImage[]
		}
	>(`/oridinal-image/result/listByType/${type}`, { pageSize, pageNum })
}

/**
 * 生成 4k 图 url
 * @param originalUrl
 * @param taskId
 * @param referedTaskOrdinalId
 * @param type
 */
export const exec4kImage = ({
	originalUrl,
	taskId,
	referedTaskOrdinalId,
	type
}: {
	originalUrl: string
	taskId: string
	referedTaskOrdinalId: string
	type: EBizPhone
}) => {
	return requestInstance
		.post<any, any>(`/task/photo/exec4k`, {
			originalUrl,
			taskId,
			referedTaskOrdinalId,
			type
		})
		.fire()
}

/**
 * 图片Python转文字
 * @param image_cut_url
 * @param type
 * @param taskId
 * @param frameCoordinates 
 */
export const imageconvertText = ({
	image_cut_url,
	type,
  taskId,
  frameCoordinates 
}: {
	image_cut_url: string
	type: number,
  taskId: string,
  frameCoordinates : string
}) => {
	return requestInstance
		.post<any, any>(`/task/photo/imgChangeText`, {
			image_cut_url,
			type,
			taskId,
			frameCoordinates 
		}).fire()
}

/**
 * 图片Python转文字
 * @param taskId
 * @param type
 * @param desType
 * @param originImgUrl
 * @param extra
 * @param prompt
 */
export const confirmDo = ({
	taskId,
	type,
  desType,
  markImgUrl,
  originImgUrl,
  prompt,
}: {
	taskId: string,
	type: number,
  desType: string,
  markImgUrl: string,
  originImgUrl: string,
  prompt: string,
}) => {
	return requestInstance
		.post<any, any>(`/task/photo/execute`, {
      taskId,
      type,
      desType,
      markImgUrl,
      originImgUrl,
      prompt,
		}).fire()
}

